// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6e213d8f","239":"bc315599","732":"87b6755a"}[chunkId] + ".chunk.js";
};